import React from 'react'
import Select from 'react-select';


class LicenseSelector extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			licenses: []
		}
		this.internal = false;
		this.query = "";
	}

	getSnapshotBeforeUpdate(nextProps) {
		// console.log(nextProps.query, this.query)
		// this.internal = nextProps.query === this.props.query;
		return this.query !== nextProps.query 
	}
	
	componentDidUpdate(nextProps, nextState, willUpdate) {
		if(!willUpdate) return
		this.query = nextProps.query;
		if (this.query.length >= 2)
			this.getLicenses();
		else
			this.emptyLicenses();
	}
	emptyLicenses = () => {
		this.setState({ licenses: [] })
	}
	getLicenses = async () => {
		try {
			const licensesRequest = await fetch('/api/v1/licenses?query=' + window.cleanEncodeURIComponent(this.query), {
				headers: {
					'Authorization': 'Bearer ' + window.AuthUtils.getTokenFromLocalStorage(),
					'Content-Type': 'application/json'
				}
			})
			if (licensesRequest.status !== 200) throw await licensesRequest.json();
			const licenses = await licensesRequest.json();
			const licensesMapedOptions = licenses.map((license) => {
				return { value: license.id, label: license.name }
			})
			this.setState({ licenses: licensesMapedOptions })
		}
		catch (e) {
		}
	}

	render() {
		if(!Object.keys(this.props.licenseToFix).length) return null
		const licensesList = this.state.licenses.slice()
		licensesList.unshift({ id: "", name: "Select license" })
		return <Select
			onChange={this.props.setSelected}
			ref={this.props.selectRef}
			placeholder={"Search licenses, e.g GPL"}
			className="basic-single"
			classNamePrefix="select"
			data-testid="select-input"
			defaultValue={this.state.licenses[0]}
			isDisabled={false}
			isLoading={false}
			isClearable={true}
			isRtl={false}
			isSearchable={true}
			noOptionsMessage={() => {
				if(!this.props.query) return "Search licenses, e.g. GPL"
				if(this.props.query.length === 1) return "Enter a minimum of 2 characters"
			}}
			options={this.state.licenses}
		/>
	}
}

export default LicenseSelector